<template>
  <div class="page-question" >
    <div class="left-right-content que clearfix" v-show="isMounted">
      <div class="c-left">
        <ul class="top-select-tit clearfix">
          <li class="active"><a tag="li" :href="baseUrl+'/gquestions?plate=3'" >普通问答</a></li>
          <li><a tag="li" :href="baseUrl+'/rquestions?plate=3'">悬赏问答</a></li>
          <li class="ask-que"><a tag="li" :href="baseUrl+'/askque?plate=3'" v-if="isLogin" >发布一个新问题</a></li>
        </ul>
        <el-timeline class="ques-list" v-if="newQuestionPage.total>0" v-loading="listLoading">
          <el-timeline-item :timestamp="item.publishDate | formatTime" placement="top" color="#ee4b58" v-for="(item, index) in newQuestionPage.list" :key="index">
            <div class="ques-item">
              <div class="item-tit"><a :href="baseUrl+'/quedetail?id='+item.id+'&plate='+item.belongSection" target="_blank">{{item.title}}</a></div>
              <div class="asker-tags clearfix">
                <a :href="baseUrl+'/home?userId='+item.userId" target="_blank" class="ask-info">
                  <span class="ask-avatar" :style="{'background-image': 'url('  + `http://iss.21teacher.com/avatar/125/${item.userId}/20.jpg` +  ')'}"></span>
                  <span class="ask-name">{{item.userName}}</span>
                </a>
                <ul class="tags clearfix">
                  <li v-for="(item_bak, index_bak) in item.tags" :key="index_bak" style="cursor: default">#{{ item_bak.tag }}</li>
                </ul>
              </div>
              <div class="ask-content">
                <a :href="baseUrl+'/quedetail?id='+item.id+'&plate='+item.belongSection" target="_blank">
                  <div v-html="item.content"></div>
                </a>
              </div>
              <div class="ans-user-much clearfix">
                <div class="ans-user clearfix">
                  <a :href="baseUrl+'/home?userId='+answerItem.userId" target="_blank"
                    class="ans-ava"
                    :style="{'background-image': 'url('  + `http://iss.21teacher.com/avatar/125/${answerItem.userId}/20.jpg` +  ')'}"
                    v-for="(answerItem) in item.answerList.slice(0, 5)" :key="answerItem.id"
                  />
                  <span class="t-tips" v-if="item.answerList.length > 0">等<span class="num">{{item.answerList.length}}</span>人正在讨论</span>
                </div>
                <div class="much">
                  <span class="item">访问量<span class="num">{{item.hits}}</span></span>
                  <span class="item">回答数<span class="num">{{item.comment}}</span></span>
                </div>
              </div>
            </div>
          </el-timeline-item>

        </el-timeline>

        <div v-else class="common-no-data">
          <img class="img" :src="emptyImg" alt="">
          <!--                    <span class="words">抱歉！您访问的页面暂无数据</span>-->
        </div>

        <div class="pagintion-f" v-if="isMounted && newQuestionPage.total>0">
          <el-pagination
                  background
                  @current-change="changePage"
                  layout="prev, pager, next,jumper"
                  :current-page="param.pageIndex"
                  :page-size="param.pageSize"
                  :total="newQuestionPage.total"
                  :hide-on-single-page="true"
          >
          </el-pagination>
        </div>


      </div>
      <div class="c-right">
        <div class="one-item">
          <div class="one-title">
            热门问答
            <i class="el-icon-refresh-right shuaxin" @click="hot"></i>
          </div>
          <ul class="articles-list">
            <li v-for="(item,index) in hotList" :key="index">
              <div class="art-tit">
                <router-link :to="'/gquestionsdetail?id='+item.id+'&plate='+item.belongSection+''" target="_blank">{{item.title}}</router-link>
              </div>
              <span class="much-count clearfix">
                <span class="much">访问量<span class="num">{{item.hits}}</span></span>
                <span class="much">回答数<span class="num">{{item.comment}}</span></span>
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  import questionApi from "../../api/question";

  import updateTdk from "@/utils/tdk";
  import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['newQuestionPage'])
  },
  data () {
    return {
      baseUrl:process.env.config.RRDH_HOST,
      headTitle: "人人动画网【官网】",
      headKeywords: "人人动画网【官网】",
      headDesc: "人人动画网【官网】",
      isMounted: false, //for control not ssr render

      listLoading: false,
      param:{
        publishStatus: 1,
        ruleIsUseful:0,
        deleteFlag: 0,
        pageIndex: 1,
        pageSize: 12,
      },
      queData:[],//列表数据
      total:0,
      emptyImg: require('@/assets/images/empty.png'),
      isLogin:false,

      hotParam:{
        pageIndex: 1,
        pageSize: 4,
        publishStatus:1, //已发布
        ruleIsUseful:0,
        deleteFlag: 0,  //正常
        getType:"hot",
      },
      hotList:[],
      hotTotal:0,
    }
  },
  tdk() {
    return {
      title: this.headTitle,
      description: this.headDesc,
      keywords: this.headKeywords,
      ssrHeadAddInfo: `<link rel="canonical" href="http://www.renrendonghua.com/gquestions">`
    };
  },
  serverPrefetch() {
    this.fetchData()
    return this.initData();
  },
  // beforeRouteUpdate(to, from, next) {
  //   this.search(1)
  //   next();
  // },
  mounted () {
    // console.log("newQuestionPage====",this.newQuestionPage)
    // console.log("newQuestionPage=list===",this.newQuestionPage.list)
    this.fetchData()
    this.initData().then(()=>{
      let re1 =new RegExp("<.+?>",'g')//匹配html标签的正则表达式，"g"是搜索匹配多个符合的内容
      this.newQuestionPage.list.forEach((item,index) =>{
        item.content = item.content.replace(re1,'')//执行替换成空字符
      })
      this.fetchDataMounted()
    })
    //thiss.search(1)
  },
  methods: {
    fetchData(){
      let plate = this.$route.query.plate
      if(plate){
        this.plate = plate
      }
      this.param.belongSection = this.plate

      let paramPageIndex = this.$route.query.toPageNum
      if(!paramPageIndex){
        paramPageIndex = 1

      }
      this.param.pageIndex =Number(paramPageIndex)
    },
    fetchDataMounted(){
      setTimeout(()=>{
        this.isMounted = true;
        if(this.global.isLogin) {
          this.isLogin = true
        }
        this.hot()
      },1500)
    },
    initData(){
      const cookies = this.$ssrContext && this.$ssrContext.cookies
      return this.$store.dispatch("FETCH_NEW_QUESTION_PAGE", {params: this.param,cookies:cookies}).finally(() => {
        this.$loading(false)
        this.setSeo();
        updateTdk.call(this);
      })
    },
    setSeo() {
      this.headTitle = "普通问答——人人动画网【官网】";
      this.headKeywords = "普通问答,动画交流,iClone,CTA";
      this.headDesc = "问答是人人动画网动画知识问答频道，可以免费发布，也可以有奖发布。";
    },
    search(page){
      let thiss = this
      thiss.listLoading = true
      thiss.param.pageIndex = page
      questionApi.getPage(thiss.param).then(reQue => {
        thiss.queData = reQue.list

        //对富文本内容处理
        let re1 =new RegExp("<.+?>",'g')//匹配html标签的正则表达式，"g"是搜索匹配多个符合的内容
        thiss.queData.forEach((item,index) =>{
          item.content = item.content.replace(re1,'')//执行替换成空字符
        })
        thiss.total = reQue.total
        thiss.param.pageIndex = reQue.pageNum
        thiss.listLoading = false
      })

    },

    hot(){
      let this_ = this
      questionApi.getPage(this_.hotParam).then(reHot => {
        this_.hotList= reHot.list
        this_.hotTotal= reHot.total
        if(this_.hotParam.pageIndex == Math.ceil(this_.hotTotal/this_.hotParam.pageSize) ){
          this_.hotParam.pageIndex =1
        }else{
          this_.hotParam.pageIndex = this_.hotParam.pageIndex+1
        }
      })
    },

    changePage(page){
      let urlNow=window.location.href

      if(urlNow.indexOf("toPageNum") > 0){
        urlNow = urlNow.substr(0,urlNow.indexOf("&toPageNum="))
      }

      let url = urlNow+"&toPageNum="+page
      window.location.href= url
    },
  }
}
</script>

<style scoped lang="less">
.c-left{
  position: relative;
}
.pagintion-f {
  padding: 20px 0 40px;
  text-align: center;
}
</style>
